<template>
  <div>
    <b-card>
      <div
        slot="header"
        class="d-flex align-items-center justify-content-between"
      >
        <span>پرونده‌های انتخاب شده</span>
        <div class="d-flex align-items-center justify-content-between">
          <b-button @click="removeAll" variant="outline-danger" class="mr-1">
            <mdicon name="trash-can" size="20" />
            <span class="ml-1">حذف همه</span>
          </b-button>
          <b-button @click="showParvandehList" variant="primary">
            <mdicon name="plus" size="20" />
            <span class="ml-1">پرونده جدید</span>
          </b-button>
        </div>
      </div>
      <b-row class="m-0 wrapper">
        <b-col
          v-for="(item, index) in items"
          :key="`a-${index}`"
          cols="12"
          class="border rounded p-3 d-flex align-items-center justify-content-between mb-2"
        >
          <div class="text-muted font-weight-bold">
            <span class="mr-1">{{ item.fullName }}</span>
            <span class="mr-1">({{ item.parvandehNumber }})</span>
            <span class="mr-1 font-weight-light">|</span>
            <span class="mr-1">{{ item.termCaption }}</span>
          </div>

          <span
            @click="removeOne(item.code)"
            class="text-danger cursor_pointer"
          >
            <mdicon name="trash-can" size="24" />
          </span>
        </b-col>
        <b-col
          v-if="!items.length"
          cols="12"
          class="bg-light rounded p-3 text-center"
        >
          {{ $lang.noFoldersExist }}
        </b-col>
      </b-row>
    </b-card>
    <div class="d-flex align-items-center justify-content-end mt-3">
      <b-button variant="outline-danger" @click="close">
        <mdicon name="close" size="24" />
        {{ $lang.close }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, ref } from "vue";

export default {
  setup(props, { emit }) {
    const localStorageName = ref("dashboard-parvandeh-codes");
    const items = ref([]);
    onMounted(() => {
      const localStorageData = localStorage.getItem(localStorageName.value);
      const parvandehCodes = JSON.parse(localStorageData);
      items.value = parvandehCodes || [];
    });
    const removeAll = () => {
      items.value = [];
      localStorage.removeItem(localStorageName.value);
    };
    const removeOne = (code) => {
      const newItems = [...items.value.filter((item) => item.code !== code)];
      items.value = [...newItems];
      localStorage.setItem(localStorageName.value, JSON.stringify(items.value));
    };

    // generate parent methods
    const showParvandehList = () => emit("showParvandehList");
    const close = inject("close");

    // return data to be used in template
    return { items, removeAll, removeOne, showParvandehList, close };
  },
};
</script>
